































import { Component, Vue, Prop } from "@/shared/vuepack";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import Pill from "@/shared/components/ui/Pill.vue";

@Component ({
  components: { CurrencyAmount, Pill }
})
export default class ContributionActivityRow extends Vue {
  @Prop()
  dateString: string;

  @Prop()
  pillText: string;

  @Prop()
  pillClass: string;

  @Prop()
  amount: number;

  @Prop()
  description: string;

  @Prop()
  subDescription: string;

  @Prop()
  statusReason: string;
}

